// extracted by mini-css-extract-plugin
export default {"AdminTopicsAddItem":"admin-topics-add-item_AdminTopicsAddItem__rlGG1","buttonsBlock":"admin-topics-add-item_buttonsBlock__B+9fV"};